import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { Form, Button, Modal, Row, Col, FormGroup, FormControl } from 'react-bootstrap'
import ColorPicker from '../ColorPicker'
import EventTypeSelector from '../EventTypeSelector'
import CopyableTextBlock from '../CopyableTextBlock'

export default class MiniSessionButton extends Component {
  state = {
    showModal: false,
    text: "Next Step",
    foregroundColor: this.props.contrastColor,
    backgroundColor: this.props.primaryColor,
    style: "basicLink",
    activeMiniSession: null,
  }

  static propTypes = {
    type: PropTypes.string.isRequired,
    miniSessionUrl: PropTypes.string.isRequired,
    primaryColor: PropTypes.string.isRequired,
    contrastColor: PropTypes.string.isRequired,
    miniSessions: PropTypes.array.isRequired
  }

  showModal = () => {
    this.setState({showModal: true})
  }

  hideModal = () => {
    this.setState({showModal: false})
  }

  get bookingUrl() {
    const { miniSessionUrl } = this.props
    const { activeMiniSession } = this.state
    
    if(activeMiniSession) {
      return `${miniSessionUrl}/${activeMiniSession.id}`
    }
    else {
      return miniSessionUrl
    }

  }

  get selectedMiniSessionName() {
    const { activeMiniSession } = this.state

    if(activeMiniSession) {
      return activeMiniSession.title
    }
    else {
      return ""
    }

  }

  renderPreview() {
    const { style, text, backgroundColor, foregroundColor } = this.state
    const { bookingUrl } = this

    switch(style) {
      case "basicLink":
        return (
          <div>
            { bookingUrl }
          </div>
        )
      case "customizedLink":
        return (
          <div>
            <a href={bookingUrl} target="_top">{ text }</a>
          </div>
        )
      case "button":
        const buttonStyle = {
          color: foregroundColor,
          display: "inline-block",
          margin: 0,
          fontWeight: "normal",
          cursor: "pointer",
          border: `1px solid ${backgroundColor}`,
          textDecoration: "none !important",
          background: backgroundColor,
          whiteSpace: "nowrap",
          padding: "6px 12px",
          fontSize: "14px",
          lineHeight: "18px",
          borderRadius: 0
        }
        return (
          <div>
            <a href={bookingUrl} style={buttonStyle} target="_top">{ text }</a>
          </div>
        )
      default:
        return null;
    }
  }

  get html() {
    const { style, text, backgroundColor, foregroundColor } = this.state
    const { bookingUrl } = this

    switch(style) {
      case "basicLink":
        return bookingUrl
      case "customizedLink":
        return `<a href="${bookingUrl} target="_top"">${text}</a>`
      case "button":
        const buttonStyle = `color: ${foregroundColor}; display: inline-block; margin: 0; font-weight: normal; cursor: pointer, border: 1px solid ${backgroundColor}; text-decoration: none !important; background: ${backgroundColor}; white-space: nowrap; padding: 6px 12px; font-size: 14px; line-height: 18px; border-radius: 0`
        return `<a href="${bookingUrl}" style="${buttonStyle}" target="_top">${text}</a>`
      default:
        return null;
    }
  }

  handleMiniSessionSelected = (event, activeMiniSession) => {
    event.preventDefault()
    this.setState({ activeMiniSession })
  }

  render() {
    const { type, miniSessions } = this.props
    const { showModal, style, text, backgroundColor, foregroundColor } = this.state

    return (
      <div>
        <div>
          <Button onClick={this.showModal} variant="primary">
            <i className="fa fa-code" />
            { " " }
            Get Embed Code
          </Button>
        </div>
        <Modal show={showModal} onHide={this.hideModal} size="lg">
          <Modal.Header closeButton>
            <Modal.Title>Customize Mini Session Link</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <Row>
              <Col sm={4}>
                <h3>Customize</h3>
                <FormGroup className="mb-2">
                  <Form.Label>Select a mini session</Form.Label>
                  <div>
                    <div className="tree-view_arrow" />
                    <a href="#" onClick={e => this.handleMiniSessionSelected(e, null)}>All Mini Sessions</a>
                  </div>
                  { miniSessions.map(miniSession =>
                    <div key={miniSession.id}>
                      <a href="#" onClick={e => this.handleMiniSessionSelected(e, miniSession)} style={styles.miniSessionLink}>
                        { miniSession.formattedDate } – { miniSession.title }
                      </a>
                    </div>
                  )}
                </FormGroup>
                <FormGroup className="mb-2">
                  <Form.Label>Choose Style</Form.Label>
                  <Form.Check
                    type="radio"
                    name="style"
                    checked={style === "basicLink"}
                    onChange={() => this.setState({style: "basicLink"})}
                    label="Link Only"
                    id="mini-session-link-only"
                  />
                  <Form.Check
                    type="radio"
                    name="style"
                    checked={style === "customizedLink"}
                    onChange={() => this.setState({style: "customizedLink"})}
                    label="Customized Link"
                    id="mini-session-customized-link"
                  />
                  <Form.Check
                    type="radio"
                    name="style"
                    checked={style === "button"}
                    onChange={() => this.setState({style: "button"})}
                    label="Button"
                    id="mini-session-button"
                  />
                </FormGroup>
                { (style === "customizedLink" || style === "button") &&
                  <FormGroup className="mb-2">
                    <Form.Label>Text</Form.Label>
                    <FormControl
                      type="text"
                      value={text}
                      onChange={(e) => this.setState({text: e.target.value})}
                    />
                  </FormGroup>
                }

                { style === "button" &&
                  <FormGroup className="mb-2">
                    <Form.Label>Button Color</Form.Label>
                    <ColorPicker
                      value={backgroundColor}
                      onChange={backgroundColor => this.setState({backgroundColor})}
                    />
                  </FormGroup>
                }

                { style === "button" &&
                  <FormGroup className="mb-2">
                    <Form.Label>Text Color</Form.Label>
                    <ColorPicker
                      value={foregroundColor}
                      onChange={foregroundColor => this.setState({foregroundColor})}
                    />
                  </FormGroup>
                }
              </Col>
              <Col sm={4}>
                <h3>Selected Mini Session</h3>
                { this.selectedMiniSessionName ?
                    <p>You have selected <strong>{ this.selectedMiniSessionName }</strong></p>
                    :
                    <p>No mini session selected</p>
                }

                <h3>Preview Link</h3>

                <div style={styles.previewStyle}>
                  { this.renderPreview() }
                </div>
              </Col>
              <Col sm={4}>
                <h3>HTML</h3>

                <p>Copy and paste the HTML below into your website to add your sign in link.</p>

                <FormGroup className="mb-2">
                  <CopyableTextBlock value={this.html} />
                </FormGroup>
              </Col>
            </Row>
          </Modal.Body>
          <Modal.Footer>
            <Button onClick={this.hideModal}>
              Close
            </Button>
          </Modal.Footer>
        </Modal>
      </div>
    )
  }
}

const styles = {
  previewStyle: {
    wordWrap: 'break-word'
  },
  embedStyle: {
    height: 300
  },
  miniSessionLink: {
    paddingLeft: 15
  }
}
